export const apisCategory = ["ADE", "MSORG"];
export const dataPlans = ["SME", "CG", "COOPERATE GIFTING", "GIFTING"];
export const networks = [
  { name: "MTN", code: 1 },
  { name: "AIRTEL", code: 2 },
  { name: "GLO", code: 3 },
  { name: "9MOBILE", code: 4 },
];
